import { cn } from '@/lib/utils'
import { Button, CardLink, Container, Section, Title } from '@/ui/components'
import { getTitleTag } from '@/utils'
import { memo } from 'react'
import { SectionLinkProps } from './type'

const SectionLink = ({
  section,
  items,
  buttons,
  title,
  titleLayout,
  gridInverted = false,
  variant = 'link'
}: SectionLinkProps) => {
  if (!items || items?.length === 0) {
    return null
  }
  const cardVariant = variant === 'shop' ? 'shop' : 'content'

  return (
    <Section
      data={section}
      className={cn('s-section-link', {
        'bg-shop-100 text-shop-400': variant === 'shop'
      })}
    >
      <Container>
        <div className={''}>
          {title && titleLayout !== '100' && (
            <div className={'align-end mb-xl flex justify-between'}>
              <Title as={getTitleTag(titleLayout)} className="h2">
                {title}
              </Title>
              {buttons?.length && (
                <div className="gap-xs flex">
                  {buttons?.map((button, i) => (
                    <Button
                      key={i?.toString()}
                      {...button}
                      size="m"
                      variant="tertiary"
                    />
                  ))}
                </div>
              )}
            </div>
          )}
          <div className="gap-xs grid grid-cols-1 lg:grid-cols-3">
            {items?.map((item, i) => {
              const sizeSmall = gridInverted
                ? i === 1 || i === 2 || i === 3 || i === 5
                : i % 2 === 0 || i === 5
              return (
                <div
                  key={i?.toString()}
                  className={cn(
                    sizeSmall ? 'lg:col-span-1' : 'lg:col-span-2 lg:row-span-2'
                  )}
                >
                  <CardLink
                    {...item}
                    variant={cardVariant}
                    showArrow={variant === 'shop'}
                  />
                </div>
              )
            })}
          </div>
        </div>
      </Container>
    </Section>
  )
}

SectionLink.displayName = 'SectionLink'

export default memo(SectionLink)
